import { Box, TableCell } from "@mui/material";
import StyledTableRow from "../../../../components/table/styled-table-row";
import { SaleItem, SaleItemRequest } from "../../../../service/model/store.model";
import { useState } from "react";
import { ConfirmationDialog } from "../../../../components/confiramation-dialog";
import TableActionButton from "../../../../components/table/table-action-button";
import SaleItemForm from "./sale-item-form";
import { EditIcon, DeleteIcon } from "../../../../shared/icons";

interface TableRowProps {
    readonly saleItem: SaleItem
    readonly editable: boolean
    readonly onEdit: (data: SaleItemRequest) => void
    readonly onDelete: (id: number) => void
}

const SaleItemTableRow: React.FC<TableRowProps> = ({ saleItem, editable, onEdit, onDelete }) => {
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showSaleItemForm, setShowSaleItemForm] = useState(false);

    const handleDelete = () => {
        // dispatch(deleteSaleItem(saleItem.id))
        onDelete(saleItem.id);
        setShowDeleteDialog(false)
    }

    const handleDeleteCancel = () => {
        setShowDeleteDialog(false)
    }

    const handleSaleItemEdit = (data: SaleItemRequest) => {
        setShowSaleItemForm(false);
        onEdit({...data, id: saleItem.id});
    };

    return (
        <>
            <StyledTableRow key={saleItem.id}>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Product</Box>{saleItem.product.name}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Quantity</Box>{saleItem.quantity}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Unit Cost</Box>{saleItem.costPrice}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Selling Price</Box>{saleItem.sellingPrice}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Total Amount</Box>{saleItem.sellingPrice * saleItem.quantity}</TableCell>
                {editable &&
                    <TableCell>
                        <Box component="div" display="inline" className="responsive-mobile-heading">Actions</Box>
                        <TableActionButton onClick={() => setShowSaleItemForm(true)} label="Edit" icon={<EditIcon />} />
                        <TableActionButton onClick={() => setShowDeleteDialog(true)} label="Delete" icon={<DeleteIcon />} />
                    </TableCell>
                }
            </StyledTableRow>
            {showSaleItemForm &&
                <SaleItemForm saleItem={saleItem} editable={true} onClose={() => setShowSaleItemForm(false)} onSubmit={handleSaleItemEdit} />
            }
            {showDeleteDialog &&
                <ConfirmationDialog show={true} message="Are you sure you want to delete?" onConfirm={handleDelete} onCancel={handleDeleteCancel} />
            }
        </>
    );
}

export default SaleItemTableRow;